export const setTravellerValue = (type, value, roomIndex) => {
    return {
        type: 'SET_TRAVELLER_VALUE',
        payload: {type, value, roomIndex}
    };
};

export const openPartyDetailsOverlay = () => {
    return {
        type: 'OPEN_PARTY_DETAILS_OVERLAY'
    };
};

export const setErrorVisibility = (errorVisibility) => {
    return {
        type: 'SET_ERROR_VISIBILITY',
        payload: { errorVisibility }
    };
};

export const closePartyDetailsOverlay = (reset = false) => {
    return {
        type: 'CLOSE_PARTY_DETAILS_OVERLAY',
        reset
    };
};

export const setNumberOfRooms = (number) => {
    return {
        type: 'SET_NUMBER_ROOMS',
        payload: {number}
    };
};

export const setChildAge = (roomIndex, childIndex, age) => {
    return {
        type: 'SET_CHILD_AGE',
        payload: {
            roomIndex,
            childIndex,
            age
        }
    };
};
